import { CandidateResumeList } from '@features/candidate/candidate-resume-list';

type ProfilesTabProps = {
  candidateId: number;
};

export const ProfilesTab = ({ candidateId }: ProfilesTabProps) => (
  <CandidateResumeList candidateId={candidateId} />
);
